import React, { useContext } from "react";
import { Checkbox } from "@mui/material";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const SelectMessageCheckbox = ({ message }) => {
  const [isChecked, setIsChecked] = React.useState(false);
  const {
    showSelectMessageCheckbox,
    setSelectedMessages,
  } = useContext(ForwardMessageContext);

  const handleSelectMessage = (e, currentMessage) => {
    const isSelected = e.target.checked;

    setIsChecked(isSelected);

    if (isSelected) {
      setSelectedMessages((prev) => [...prev, currentMessage]);
      return;
    }

    setSelectedMessages((prev) => prev.filter((item) => item.id !== currentMessage.id));
  };

  if (showSelectMessageCheckbox) {
    return (
      <Checkbox
        color="primary"
        checked={isChecked}
        onChange={(e) => handleSelectMessage(e, message)}
      />
    );
  }

  return null;
};

export default SelectMessageCheckbox;
